import { gql, useLazyQuery } from '@apollo/client'
import { useEffect } from 'react'
import { ViewedBrandsQuery, ViewedBrandsQueryVariables } from 'types/graphql'
import { useCurrentUser } from 'modules/auth/useCurrentUser'

export const viewedBrandFragment = gql`
  fragment ViewedBrandFragment on Brand {
    id
    title
    slug
    primaryImageFullPath
  }
`

const getViewedBrandsQuery = gql`
  query ViewedBrands {
    list(type: Viewed) {
      id
      brands(take: 8) {
        items {
          ...ViewedBrandFragment
        }
      }
    }
  }
  ${viewedBrandFragment}
`

export const useViewedBrands = () => {
  const { user } = useCurrentUser()
  const [fetchViewedBrands, { data, loading }] = useLazyQuery<ViewedBrandsQuery, ViewedBrandsQueryVariables>(getViewedBrandsQuery, {
    fetchPolicy: 'cache-and-network'
  })

  useEffect(() => {
    if (user) {
      fetchViewedBrands()
    }
  }, [user, fetchViewedBrands])

  return { data, loading }
}
